import React from 'react'

import LoadingWrapper from '../../widgets/loading'
import { fmtCount } from '../helpers/helper'

/* Body of an expanded row: one bar per day, newest first.
 *
 * Bars scale against the busiest day in the window rather than an absolute axis, so the
 * strip reads as a shape (which days were heavy) instead of a volume comparison.
 */
const DailyStrip = ({ state }) => {
  if (!state || state.loading) {
    return (
      <div className='am-daily am-daily-loading'>
        <LoadingWrapper
          type='spin'
          color='#9aa0a6'
          height={24}
          width={24}
        />
        <span>Loading daily breakdown…</span>
      </div>
    )
  }
  if (state.error) {
    return <div className='am-daily am-daily-error'>{state.error}</div>
  }

  const items = state.items || []
  if (items.length === 0) {
    return <div className='am-daily am-muted'>No daily data for this mailbox.</div>
  }

  // Floor the divisor at 1: an all-zero or all-null window would otherwise divide by zero.
  const peak = Math.max(1, ...items.map((day) => day.sent || 0))

  return (
    <div className='am-daily'>
      <div className='am-daily-bars'>
        {items.map((day, index) => {
          const isUnknown = day.sent === null || day.sent === undefined
          // Floor a non-zero day at 2% so a single message on a busy week still draws
          // something, instead of rounding away to an empty column.
          const height = isUnknown || !day.sent ? 0 : Math.max(2, Math.round((day.sent / peak) * 100))
          return (
            <div
              key={day.date}
              className='am-daily-col'
            >
              <div className={'am-daily-count' + (day.sent === 0 ? ' am-muted' : '')}>
                {fmtCount(day.sent)}
              </div>
              <div className='am-daily-track'>
                {/* No bar at all for a null or zero day. A null is "we could not read
                    this", and the minimum bar height would otherwise draw it as a small
                    but real volume — the count above already says 0 or an em dash. */}
                {height > 0 ? (
                  <div
                    className='am-daily-bar'
                    style={{ height: `${height}%` }}
                  />
                ) : null}
              </div>
              {/* Item 0 is the rolling 24h window, not a calendar day — hence "Today". */}
              <div className='am-daily-label'>{index === 0 ? 'Today' : day.date.slice(5)}</div>
            </div>
          )
        })}
      </div>
      {/* The one place the trailing-24h vs UTC-calendar-day asymmetry is explained to the
          user. Do not drop it — without it the first bar silently means something else. */}
      <div className='am-daily-caption'>
        {`last ${items.length} days · Today = trailing 24h, earlier days = UTC calendar days${state.path ? ` · ${state.path}` : ''}`}
      </div>
    </div>
  )
}

export default DailyStrip
